import React from "react";

function ProgressBarContainer({className, progress, info, color}) {
  return (
    <div className={`ds-progressBar ${className}`}>
      <div className="bar" style={{width: `${progress}%`}}>
        {`${info || progress}%`}
        <div className="animatedDot"><span></span></div>
      </div>
    </div>
  );
}

export default ProgressBarContainer;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/ProgressBarContainer.js